import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className?: string;
  children?: React.ReactNode;
}

export const SortingMenuList = styled.div<IProps>`
  ${mixin.flex({ justify: 'flex-end' })};
  gap: 20px;

  .btn {
    font-size: 16px;
    line-height: 130%;
    color: #999;

    &.active {
      color: #000;
    }
  }
`;
